import React, { ComponentType, ReactElement, useEffect } from 'react'

import { preloadPage } from 'helpers/lazyPreload'

interface IProps {
  children: ReactElement
  nextPage?: ComponentType<any> & { preload?: () => Promise<void> }
}

export const PreloadPageWrapper: React.FC<IProps> = ({
  children,
  nextPage,
}) => {
  useEffect(() => {
    preloadPage(nextPage)
  }, [nextPage])

  return children
}
